import React, { useEffect, useState } from "react";
import {
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { DashboardWidgetsClient } from "../../../../../api/DashboardWidgetsClient";
import { REACT_APP_PORTAL_API_URL } from "../../../../../KeyVariables";
import { useTranslation } from 'react-i18next';
import PatientHistoryTable from "./Table";
import { PatientHistoryItemDTO } from "../../../../../api/DashboardWidgetDTO";
import { PatientWidgetProps } from "../../PatientDashboard";

export interface PatientHistoryListDTO {
  items: PatientHistoryItemDTO[];
  name: string;
  showTime: boolean;
  showDoctor: boolean;
  color: string;
}

export const PatientHistoryWidget = ({ patientId }: PatientWidgetProps) => {
  const [items, setItems] = useState<PatientHistoryItemDTO[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation("Portal");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await new DashboardWidgetsClient(REACT_APP_PORTAL_API_URL).history(patientId > 0 ? patientId : undefined);
      setItems(data);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const requiredList: PatientHistoryListDTO = {
    items: items.filter(x => !x.done).sort((a, b) => b.date - a.date),
    name: t('Portal_NotCompletedServices'),
    color: "rgba(0, 119, 255, 0.9)",
    showTime: false,
    showDoctor: false
  };

  const doneList: PatientHistoryListDTO = {
    items: items.filter(x => x.done).sort((a, b) => b.date - a.date),
    showTime: true,
    name: t('Portal_CompletedServices'),
    color: "rgba(0, 255, 0, 0.9)",
    showDoctor: true
  }

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <>
      <Grid container direction={"row"} spacing={1}>
        <Grid item xs={isMobile ? 12 : 6}>
          <PatientHistoryTable key={1} list={requiredList} loading={isLoading} patientId={patientId || 0}/>
        </Grid>

        <Grid item xs={isMobile ? 12 : 6}>
          <PatientHistoryTable key={2} list={doneList} loading={isLoading} patientId={patientId || 0}/>
        </Grid>
      </Grid >
    </>
  );
};
